import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactUsComponent } from './core/contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './core/privacy-policy/privacy-policy.component';
import { ProductsComponent } from './core/products/products.component';
import { ReceptionComponent } from './core/reception/reception.component';
import { LoginComponent } from './security/login/login.component';
import { ForgotPasswordComponent } from './security/forgot-password/forgot-password.component';
import { RegisterComponent } from './security/register/register.component';
import { AuthGuard } from './auth.guard';
import { VerifyEmailComponent } from './security/verify-email/verify-email.component';
import { ResetPasswordComponent } from './security/reset-password/reset-password.component';
import { TermsComponent } from './core/terms/terms.component';
import { CustomerProfileComponent } from './security/customer-profile/customer-profile.component';
import { PaymentComponent } from './shared/payment/payment.component';
import { DonateComponent } from './commerce/donate/donate.component';

import { AdminDashboardComponent } from './core/admin/dashboard/admin-dashboard.component';
import { AdminUserManagementComponent } from './core/admin/dashboard/admin-user-management.component';
import { AdminChapterManagementComponent } from './core/admin/dashboard/admin-chapter-management.component';
import { KSolveAdminGuard } from './core/admin/ksolve-admin.guard';
import { CoursesCatalogComponent } from './core/courses/courses-catalog.component';

/*
 * Application Routing Module
 *
 * TECHNOLOGY:
 * This module uses Angular Router to manage navigation between different views (components)
 * within the Single Page Application (SPA). It maps URL paths to specific Components.
 *
 * KEY FEATURES:
 * 1. Routes Definition: An array of route objects defining the path and the component to render.
 * 2. AuthGuard: Used in the 'canActivate' property to protect routes that require user login.
 * 3. Redirects: 'redirectTo' is used to define a default route (e.g., redirecting empty '' to '/reception').
 */
const routes: Routes = [
  {
    path: '',
    redirectTo: '/reception',
    pathMatch: 'full'
  },
  {
    path: 'reception',
    component: ReceptionComponent
  },
  {
    path: 'courses',
    component: CoursesCatalogComponent
  },
  {
    path: 'books',
    redirectTo: '/courses',
    pathMatch: 'full'
  },
  {
    path: 'products',
    component: ProductsComponent
  },
  {
    path: 'contact-us',
    component: ContactUsComponent
  },

  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'terms',
    component: TermsComponent
  },
  {
    path: 'privacypolicy.html',
    component: PrivacyPolicyComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: 'verify-email',
    component: VerifyEmailComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'my-account',
    component: CustomerProfileComponent,
    /* 
     * TECHNOLOGY: Route Guard
     * 'canActivate' with [AuthGuard] ensures this route is only accessible if the user 
     * is authenticated (has a valid token). If not, they are redirected to login.
     */
    canActivate: [AuthGuard]
  },
  {
    path: 'payment',
    component: PaymentComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'donate',
    component: DonateComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'middle-school-math',
    loadChildren: () => import('./middle-school-math/routes').then(m => m.routes)
  },
  {
    path: 'admin/dashboard',
    component: AdminDashboardComponent,
    canActivate: [KSolveAdminGuard]
  },
  {
    path: 'admin/users',
    component: AdminUserManagementComponent,
    canActivate: [KSolveAdminGuard]
  },
  {
    path: 'admin/chapters',
    component: AdminChapterManagementComponent,
    canActivate: [KSolveAdminGuard]
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
